import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import {
  CdfiProfile,
  ProfileHistoryItem,
  CdfiProfileSummary,
} from '../models/profile.model';
import { PaginatedResponse } from '../../../shared/interfaces/pagination';
import { User, UserDetails } from '../../../shared/models/user';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiBaseUrl;

  getProfile(): Observable<CdfiProfile> {
    return this.http.get<CdfiProfile>(`${this.apiUrl}/api/cdfi/profile`);
  }

  updateProfile(payload: Partial<CdfiProfile>): Observable<CdfiProfile> {
    return this.http.patch<CdfiProfile>(
      `${this.apiUrl}/api/cdfi/profile`,
      payload,
    );
  }

  getHistory(
    page = 1,
    pageSize = 10,
  ): Observable<PaginatedResponse<ProfileHistoryItem>> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('page_size', pageSize.toString());

    return this.http.get<PaginatedResponse<ProfileHistoryItem>>(
      `${this.apiUrl}/api/cdfi/profile/history`,
      {
        params,
        headers: {
          'X-Skip-Loader': 'true',
        },
      },
    );
  }

  getCdfiProfiles(
    page: number,
    pageSize: number,
    searchQuery?: string,
  ): Observable<PaginatedResponse<CdfiProfile>> {
    let params = new HttpParams();
    params = params.set('page', page.toString());
    params = params.set('page_size', pageSize.toString());
    if (searchQuery) {
      params = params.set('search', searchQuery);
    }
    return this.http.get<PaginatedResponse<CdfiProfile>>(
      `${this.apiUrl}/api/cdfi/profiles`,
      {
        params,
        headers: {
          'X-Skip-Loader': 'true',
        },
      },
    );
  }

  getAnonymousCdfiProfiles(
    page: number,
    pageSize: number,
    searchQuery?: string,
  ): Observable<PaginatedResponse<CdfiProfile>> {
    let params = new HttpParams();
    params = params.set('page', page.toString());
    params = params.set('page_size', pageSize.toString());
    if (searchQuery) {
      params = params.set('search', searchQuery);
    }
    return this.http.get<PaginatedResponse<CdfiProfile>>(
      `${this.apiUrl}/api/cdfi/public/profiles`,
      {
        params,
        headers: {
          'X-Skip-Loader': 'true',
        },
      },
    );
  }
  getCdfiProfileDetails(profileName: string): Observable<CdfiProfile> {
    return this.http.get<CdfiProfile>(
      `${this.apiUrl}/api/cdfi/${profileName}/profile`,
    );
  }
  getAnonymousCdfiProfileDetails(profileName: string): Observable<CdfiProfile> {
    return this.http.get<CdfiProfile>(
      `${this.apiUrl}/api/cdfi/public/${profileName}/profile`,
    );
  }

  getSMEUserProfileDetails(user_id: string): Observable<UserDetails> {
    return this.http.get<UserDetails>(
      `${this.apiUrl}/api/sme/user/${user_id}/profile`,
    );
  }

  getUserProfileDetails(): Observable<UserDetails> {
    return this.http.get<UserDetails>(`${this.apiUrl}/api/user/profile`);
  }

  updateUserProfileDetails(payload: Partial<User>): Observable<Partial<User>> {
    return this.http.patch<Partial<User>>(
      `${this.apiUrl}/api/user/profile`,
      payload,
    );
  }

  getCdfiProfileSummary(): Observable<CdfiProfileSummary> {
    return this.http.get<CdfiProfileSummary>(
      `${this.apiUrl}/api/sme/dashboard/summary`,
    );
  }
}
